import {FieldTypes} from '../_interface/field-types.enum';

const complexTypes = [
	FieldTypes.prototype,
	FieldTypes.instance,
];
const widgetTypes = [
	FieldTypes.widget
];

const visualTypes = [
	FieldTypes.label
];

const complexOrWidgetTypes = [...complexTypes, ...widgetTypes];
export const isComplexFn = (type: FieldTypes) => complexTypes.includes(type);
export const isComplexInstanceFn = (type: FieldTypes) => type === FieldTypes.instance;
export const isComplexProtoFn = (type: FieldTypes) => type === FieldTypes.prototype;
export const isWidgetFn = (type: FieldTypes) => widgetTypes.includes(type);
export const isComplexOrWidgetFn = (type: FieldTypes) => complexOrWidgetTypes.includes(type);
export const isVisualFn = (type: FieldTypes) => visualTypes.includes(type);

